const PREVIEW_MAX_LENGTH = 180;

function stripHtml(value) {
  if (!value || typeof value !== 'string') return '';
  return value
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function truncate(value, maxLength = PREVIEW_MAX_LENGTH) {
  if (!value) return '';
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1)}…`;
}

function getStepKind(stepId, stepType) {
  if (stepId === 'start') return 'start';
  const normalized = (stepType || 'html').toLowerCase();
  if (normalized === 'form') return 'form';
  if (normalized === 'photo') return 'photo';
  return 'html';
}

export function buildNodeDataFromStep(step, showDetailedContent = false) {
  const id = step?.id || '';
  const nodeKind = getStepKind(id, step?.type);
  const heading = step?.heading || (nodeKind === 'start' ? 'Start' : id);
  const previewText =
    nodeKind === 'form'
      ? step?.slug
        ? `Form: ${step.slug}`
        : 'Form step (no form selected)'
      : nodeKind === 'photo'
        ? step?.label
          ? `Photo: ${step.label}`
          : 'Photo step (no label)'
        : truncate(stripHtml(step?.text || ''));

  return {
    label: heading,
    nodeKind,
    stepType: step?.type || 'html',
    heading,
    previewText,
    slug: step?.slug || '',
    photoLabel: step?.label || '',
    showDetailedContent,
  };
}

export function buildFlowNode(step, position, showDetailedContent = false) {
  return {
    id: step.id,
    data: buildNodeDataFromStep(step, showDetailedContent),
    position,
    sourcePosition: 'right',
    targetPosition: 'left',
    type: 'workflowStep',
  };
}
